
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../node_modules/babel-loader/lib/index.js??ref--0!./students.js") );
			}, "route-students");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/students.js
// module id = null
// module chunks = 